'use client';

import { useEffect } from 'react';

const ConsoleSignature = () => {
  useEffect(() => {
    console.log(
      `
        %c██████████████████████████████            ▓▓▓███████
        ██████████████████████████████        █▓████████████
        ██████████████████████████████     ▓████████████████
        ██████████████████████████████  █▓██████████████████
        █████████████████████████████ ▓█████████████████████
        ████████████████████████████████████████████████████
        ███████████████████████████▓████████████████████████
        ████████████████████████████████████████████████████
        █████████████████████████▓██████████████████████████
        ████████████████████████████████████████████████████
        ████████████████████████████████████████████████████
        █████████████████████▓ █████████████████████████████
        ██████████████████▓█  ██████████████████████████████
        ████████████████▓     ██████████████████████████████
        ████████████▓█        ██████████████████████████████
        ███████▓▓▓            ██████████████████████████████
      `
        .split('\n')
        .map((line) => line.trim())
        .join('\n'),

      'color: #fc5651'
    );

    console.log(
      '%cSite by Mashvp',
      `color: #f5e4e1; font-weight: bold; font-size: 24px`
    );

    console.log(
      '%cLike what you see? Find out more at https://mashvp.com/',
      'color: #fbdcd7'
    );
  }, []);

  return null;
};

export default ConsoleSignature;
